module.exports = __webpack_public_path__ + "static/Hurun2019-c9a2038622e95f852db973728cbdb467.png";